namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_notebook2, {

		Top_edge: { pointerEvents: 'auto' },
		Left_edge: { pointerEvents: 'auto' },
		Bottom_edge: { pointerEvents: 'auto' },
		Right_edge: { pointerEvents: 'auto' },
		Top_left_edge: { pointerEvents: 'auto' },
		Top_right_edge: { pointerEvents: 'auto' },
		Bottom_left_edge: { pointerEvents: 'auto' },
		Bottom_right_edge: { pointerEvents: 'auto' },
		Left_top_edge_ratio: { pointerEvents: 'auto' },
		Left_bottom_edge_ratio: { pointerEvents: 'auto' },
		Right_bottom_edge_ratio: { pointerEvents: 'auto' },
		Right_top_edge_ratio: { pointerEvents: 'auto' },
		Top_left_edge_ratio: { pointerEvents: 'auto' },
		Top_right_edge_ratio: { pointerEvents: 'auto' },
		Bottom_left_edge_ratio: { pointerEvents: 'auto' },
		Bottom_right_edge_ratio: { pointerEvents: 'auto' },

	} )

}
